import { render } from "./PaymentStepComponent.vue?vue&type=template&id=e70969ea&ts=true"
import script from "./PaymentStepComponent?vue&type=script&lang=ts"
export * from "./PaymentStepComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__